import React, { useState, useEffect } from "react";


export default function PineridgeAboutSection() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div id="pineridge-about-section" className="text-dark-green font-['Cormorant_Garamond',serif] bg-light-beige">
      {/* Content */}
      <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* Left copy */}
        <section className="lg:col-span-6 xl:col-span-6" style={{ transform: 'translateY(-15%)' }}>
          {/* Eyebrow with dot and rule */}
          <div className="mb-6 flex items-center gap-3" data-aos="fade-up">
            <span className="relative flex h-2 w-2">
              <span className="animate-pulse absolute inline-flex h-full w-full rounded-full bg-beige opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-dark-green"></span>
            </span>
            <span className="text-sm tracking-[0.3em] uppercase text-dark-green font-semibold">Welcome to</span>
            <span className="flex-1 h-px bg-dark-green" />
          </div>

          {/* Title with subtle decorative element */}
          <div className="mb-8" data-aos="fade-up">
            <h1 className="text-4xl md:text-6xl font-bold text-dark-green leading-tight">
              Pineridge Hotel
            </h1>
          </div>

          {/* Paragraphs */}
          <div className="prose max-w-none text-base md:text-lg leading-relaxed text-gray-800 space-y-6" data-aos="fade-up">
            <p>
            Surrounded by the soaring Himalayas, Pineridge Hotel has delighted visitors for over decades with its landmark colonial architecture.
            </p>
            <p>
            Our reputation for impeccable hospitality stretches back to the hotel’s foundation in 1974, while our location immerses you in the very best the town has to offer.
            </p>
          </div>

          {/* Rating display */}
          <div className="mt-10 flex items-center space-x-4" data-aos="fade-up">
            <div className="flex items-center">
              <span className="text-3xl md:text-4xl font-bold text-dark-green">4.0</span>
              <span className="text-lg md:text-xl text-gray-600 ml-2">/ 5</span>
            </div>
            <div className="flex flex-col">
              <div className="flex gap-1" style={{ color: '#C0B283' }}>
                {[...Array(5)].map((_, i) => (
                  <svg key={i} viewBox="0 0 20 20" className="h-5 w-5" fill="currentColor">
                    <path d="M10 15.27 16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19 10 15.27z"/>
                  </svg>
                ))}
              </div>
              <p className="text-sm text-gray-600 mt-1">Based on 621+ reviews</p>
            </div>
          </div>
        </section>

        {/* Right images */}
        <aside className="lg:col-span-6 xl:col-span-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Tall main image */}
          <div className="md:col-span-1 order-1" data-aos="fade-right">
            <div className="overflow-hidden rounded-lg shadow-xl border border-beige" style={!isMobile ? { transform: 'scaleY(1.20) translateY(8%)' } : {}}>
              <img
                src="/about.webp"
                alt="Hotel facade"
                className="h-auto w-full object-cover hover:scale-[1.02] transition-transform duration-700"
              />
            </div>
          </div>

          {/* Two stacked images */}
          <div className="flex flex-col gap-6 order-2">
            <div className="overflow-hidden rounded-lg shadow-xl border border-beige" data-aos="fade-left">
              <img
                src="/3.webp"
                alt="Ornate entrance"
                className="h-auto w-full object-cover hover:scale-[1.02] transition-transform duration-700"
              />
            </div>
            <div className="overflow-hidden rounded-lg shadow-xl border border-beige scale-y-75" data-aos="fade-left">
              <img
                src="/6001.webp"
                alt="Lobby frontage"
                className="h-auto w-full object-cover hover:scale-[1.02] transition-transform duration-700"
              />
            </div>
          </div>
        </aside>
      </main>
    </div>
  );
}